import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkothrud() {


const cardData = {
keyword: "Cab Service in Kothrud",
headingDescription: "Citysky Cabs provides convenient Cab Service in Kothrud for residents, students, working professionals, families, corporate travellers and visitors who need dependable transportation within Pune and for longer outstation journeys. The service covers local travel around Kothrud and nearby Karve Nagar, Bavdhan, Paud Road, Deccan and other Pune areas, along with direct airport transportation to and from Pune Airport. Passengers can arrange one-way and round-trip cabs for popular destinations such as Mumbai, Shirdi, Nashik, Lonavala, Mahabaleshwar, Bhimashankar, Alibaug, Kolhapur, Goa, Jejuri and Ashtavinayak pilgrimage locations. Private cab travel is suitable for daily commuting, airport transfers, railway station travel, business requirements, family holidays and religious journeys. Citysky Cabs supports flexible pickup and drop-off arrangements with vehicle choices suited to individuals, families and groups travelling from Kothrud and surrounding localities.",
topPlaces: [
{
title: "Kothrud",
description: "Kothrud is one of Pune's established residential and educational areas, with housing societies, colleges, offices, shopping destinations and everyday commercial activity. Cab services from Kothrud provide convenient transportation for local commuting, airport transfers and outstation journeys."
},
{
title: "Karve Nagar",
description: "Karve Nagar is a well-connected residential and educational locality adjoining Kothrud. Private cabs can provide convenient travel between Karve Nagar and other Pune destinations, as well as direct transportation for airport, railway station and outstation trips."
},
{
title: "Bavdhan",
description: "Bavdhan is a growing residential area situated close to Kothrud and the western Pune corridor. Cab transportation is useful for residents travelling toward offices, educational institutions, airports, railway stations and popular destinations outside Pune."
},
{
title: "Deccan Gymkhana",
description: "Deccan Gymkhana is a prominent central Pune area with educational institutions, commercial establishments, restaurants and cultural destinations. A private cab from Kothrud provides convenient connectivity for business, personal and daily travel."
},
{
title: "Pune Airport",
description: "Pune Airport is an important travel hub for passengers from Kothrud and western Pune. Direct airport cab services are convenient for travellers carrying luggage and following fixed domestic or international flight schedules."
},
{
title: "Pune Railway Station",
description: "Pune Railway Station serves passengers travelling across Maharashtra and to other parts of India. Cab transportation from Kothrud can provide direct pickup and drop-off for families, individuals, students and business travellers."
},
{
title: "Mumbai",
description: "Mumbai is a major destination for business, personal and family travel from Pune. A private cab from Kothrud provides direct intercity transportation and can be arranged for one-way or round-trip journeys."
},
{
title: "Shirdi",
description: "Shirdi is a major pilgrimage destination visited by devotees throughout the year. Travellers from Kothrud can arrange private cab transportation for direct journeys, including return trips planned around temple visits."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a popular hill station for weekend holidays and family getaways. A private cab from Kothrud provides convenient road travel and can be combined with Panchgani, Mapro Garden and other nearby attractions."
},
{
title: "Goa",
description: "Goa is a popular long-distance destination for holidays, family vacations and group travel. Travellers from Kothrud can arrange a private cab for direct road transportation with one-way, round-trip or customized multi-day options."
}
],
services: [
{
name: "Cab service in Kothrud",
description: "Cab service in Kothrud provides private transportation for local commuting, office travel, airport transfers, railway station trips and outstation journeys. Pickup and drop-off arrangements can be planned around the passenger's preferred schedule."
},
{
name: "Cab service in Kothrud Pune",
description: "Cab service in Kothrud Pune supports residents, professionals, families, students and visitors travelling across Pune. Private cabs can also be arranged for airports, railway stations, business locations and long-distance destinations."
},
{
name: "Taxi service in Kothrud",
description: "Taxi service in Kothrud provides convenient private transportation for daily travel, business requirements, airport transfers and planned outstation trips. Vehicle selection can be based on passenger count, luggage and journey requirements."
},
{
name: "Taxi service in Kothrud Pune",
description: "Taxi service in Kothrud Pune offers direct transportation for local and intercity journeys. It is suitable for residents, corporate travellers, families, students and visitors requiring convenient connectivity from western Pune."
},
{
name: "Kothrud cab service",
description: "Kothrud cab service supports transportation within the locality and toward major Pune destinations. Customers can arrange private cabs for office commuting, shopping, airport travel, railway station transfers and outstation journeys."
},
{
name: "Kothrud taxi service",
description: "Kothrud taxi service provides private transportation for everyday and planned travel. The service can support local rides as well as longer journeys toward Mumbai, Shirdi, Nashik, Mahabaleshwar, Goa and other destinations."
},
{
name: "Cab booking in Kothrud",
description: "Cab booking in Kothrud allows passengers to arrange private transportation in advance for local and outstation trips. Pickup location, destination, travel timing and suitable vehicle requirements can be considered during trip planning."
},
{
name: "Cabs in Kothrud Pune",
description: "Cabs in Kothrud Pune provide transportation for individuals, families, students, professionals and groups. Local commuting, airport transfers, railway station travel and long-distance road journeys can all be arranged."
},
{
name: "Cab near me in Kothrud",
description: "Cab near me in Kothrud is useful for passengers looking for convenient transportation around their locality. Private cabs can be arranged for nearby destinations, offices, hotels, airports, railway stations and longer journeys."
},
{
name: "Taxi near me in Kothrud",
description: "Taxi near me in Kothrud provides a practical travel option for passengers requiring transportation around western Pune. It can support daily commuting, business travel, airport transfers and scheduled outstation journeys."
},
{
name: "Best cab service in Kothrud",
description: "Best cab service in Kothrud supports a broad range of transportation requirements, including local travel, corporate commuting, airport transfers and outstation routes. Customers can select a suitable vehicle based on passenger and luggage requirements."
},
{
name: "Affordable cab service in Kothrud",
description: "Affordable cab service in Kothrud provides a practical private transportation option for daily travel and longer road journeys. Vehicle choices can be matched with the number of passengers and the nature of the planned trip."
},
{
name: "Reliable taxi service Kothrud",
description: "Reliable taxi service Kothrud supports scheduled travel for residents, professionals, families, students and visitors. Private transportation can be arranged for local destinations, airports, railway stations and popular outstation routes."
},
{
name: "Kothrud to Pune Airport cab",
description: "Kothrud to Pune Airport cab provides direct transportation for passengers travelling from western Pune to the airport. It is convenient for travellers carrying luggage and planning their journey around scheduled flight timings."
},
{
name: "Pune Airport to Kothrud cab",
description: "Pune Airport to Kothrud cab provides direct transportation for arriving passengers travelling toward Kothrud and nearby western Pune areas. It is suitable for residents, visitors, families and business travellers."
},
{
name: "Kothrud to Pune Airport taxi",
description: "Kothrud to Pune Airport taxi provides private airport transportation for passengers requiring a direct ride from Kothrud to the airport. The service is useful for domestic and international travellers with fixed departure schedules."
},
{
name: "Kothrud to Pune Airport cab fare",
description: "Kothrud to Pune Airport cab fare can depend on factors such as vehicle category, travel timing, route conditions and service requirements. Customers can select a suitable cab according to their airport transportation needs."
},
{
name: "Cheap airport cab from Kothrud",
description: "Cheap airport cab from Kothrud provides a practical option for passengers looking for economical private transportation to Pune Airport. It is suitable for individuals, families and professionals travelling with luggage."
},
{
name: "outstation cab service in Kothrud",
description: "outstation cab service in Kothrud provides direct private transportation from western Pune toward Maharashtra, Goa and other long-distance destinations. One-way, round-trip and customized journeys can be arranged."
},
{
name: "One-way cab from Kothrud",
description: "One-way cab from Kothrud is suitable for passengers travelling to another city without requiring a return journey. It can be useful for business trips, family visits, relocation and personal travel."
},
{
name: "Round-trip cab from Kothrud",
description: "Round-trip cab from Kothrud provides private transportation for travellers who plan to return after completing their destination visit. It is suitable for holidays, pilgrimages, business trips and family outings."
},
{
name: "Kothrud to Mumbai cab",
description: "Kothrud to Mumbai cab provides direct intercity transportation for business, personal and family travel. The journey can be arranged toward the passenger's preferred destination in Mumbai with one-way or return options."
},
{
name: "Kothrud to Shirdi cab",
description: "Kothrud to Shirdi cab provides private transportation for devotees and families visiting the Sai Baba pilgrimage destination. One-way and round-trip arrangements can be planned according to the duration of the visit."
},
{
name: "Kothrud to Nashik cab",
description: "Kothrud to Nashik cab provides convenient private transportation for pilgrimage, business and leisure travel. Travellers can also include Trimbakeshwar, Panchavati and other Nashik destinations in their itinerary."
},
{
name: "Kothrud to Lonavala cab",
description: "Kothrud to Lonavala cab provides direct transportation for weekend trips and family outings. The journey can include Khandala, Bhushi Dam, Tiger Point and other nearby sightseeing destinations."
},
{
name: "Kothrud to Mahabaleshwar cabm",
description: "Kothrud to Mahabaleshwar cabm provides private transportation for travellers planning a hill-station journey from Kothrud. The trip can be customized for Mahabaleshwar, Panchgani, Mapro Garden and nearby attractions."
},
{
name: "Kothrud to Bhimashankar cab",
description: "Kothrud to Bhimashankar cab provides private transportation for devotees and nature travellers visiting the Jyotirlinga temple and surrounding forest region. Same-day and extended pilgrimage journeys can be arranged."
},
{
name: "Kothrud to Alibaug cab",
description: "Kothrud to Alibaug cab provides direct road transportation toward the Konkan coast. Families and groups can use the service for beach holidays, fort visits and weekend trips around Alibaug."
},
{
name: "Kothrud to Kolhapur cab",
description: "Kothrud to Kolhapur cab provides private intercity transportation for pilgrimage, business and family journeys. Travellers can include Mahalaxmi Temple, Rankala Lake and Panhala Fort in their travel plans."
},
{
name: "Kothrud to Goa cab",
description: "Kothrud to Goa cab provides private long-distance transportation for travellers planning a holiday in Goa. One-way, round-trip and customized multi-day travel arrangements can be planned for families and groups."
},
{
name: "Kothrud to Jejuri cab",
description: "Kothrud to Jejuri cab provides convenient private transportation for devotees visiting Khandoba Temple. The journey can also be combined with nearby pilgrimage destinations such as Morgaon and Narayanpur."
},
{
name: "Kothrud to Ashtavinayak Cab",
description: "Kothrud to Ashtavinayak Cab provides private transportation for devotees planning an Ashtavinayak temple circuit. Multi-stop journeys can be organized around the eight important Ganesha temples with suitable travel planning."
},
{
name: "outstation cab service in Karve Nagar",
description: "outstation cab service in Karve Nagar provides private transportation from the Karve Nagar area toward Maharashtra, Goa and other destinations. One-way and round-trip journeys can be arranged for holidays, business trips and pilgrimages."
},
{
name: "one-way cab from Karve Nagar",
description: "one-way cab from Karve Nagar is suitable for passengers travelling directly to another city without requiring a return cab. It can be used for business travel, relocation, family visits and personal journeys."
},
{
name: "Round-trip taxi from Karve Nagar",
description: "Round-trip taxi from Karve Nagar provides private transportation for both onward and return journeys. It is useful for weekend holidays, pilgrimages, family trips and business travel requiring a planned return."
},
{
name: "Karve Nagar to Mumbai Cab",
description: "Karve Nagar to Mumbai Cab provides direct intercity transportation for passengers travelling toward Mumbai for business, family or personal requirements. The trip can be arranged according to the preferred destination in Mumbai."
},
{
name: "Karve Nagar to Shirdi cab",
description: "Karve Nagar to Shirdi cab provides convenient private transportation for devotees and families visiting Shirdi. Travellers can select one-way or round-trip arrangements according to their pilgrimage schedule."
},
{
name: "Karve Nagar to Nashik cab",
description: "Karve Nagar to Nashik cab provides direct private transportation for religious, business and leisure journeys. Travellers can also plan visits to Trimbakeshwar, Panchavati and other Nashik-area destinations."
},
{
name: "Karve Nagar to Lonavala cab",
description: "Karve Nagar to Lonavala cab provides private transportation for weekend getaways and family outings. The journey can be customized to include Khandala and popular sightseeing destinations around Lonavala."
},
{
name: "Karve Nagar to Mahabaleshwar cab",
description: "Karve Nagar to Mahabaleshwar cab provides convenient private travel for hill-station holidays. Travellers can include Panchgani, Mapro Garden, Venna Lake and other nearby attractions in their itinerary."
},
{
name: "Karve Nagar to Bhimashankar cab",
description: "Karve Nagar to Bhimashankar cab provides direct private transportation for pilgrimage and nature trips. The journey can be arranged as a same-day visit or a longer trip depending on the travel plan."
},
{
name: "Karve Nagar to Alibaug cab",
description: "Karve Nagar to Alibaug cab provides private road transportation toward the Konkan coast. It is suitable for families and groups planning beach holidays, fort visits and weekend travel around Alibaug."
},
{
name: "Karve Nagar to Kolhapur cab",
description: "Karve Nagar to Kolhapur cab provides private intercity transportation for religious, business and personal journeys. Travellers can include Mahalaxmi Temple, Panhala Fort and other Kolhapur destinations."
},
{
name: "Karve Nagar to Goa cab",
description: "Karve Nagar to Goa cab provides long-distance private transportation for travellers planning a Goa holiday. One-way, round-trip and customized multi-day journeys can be arranged for families and groups."
},
{
name: "Karve Nagar to Jejuri cab",
description: "Karve Nagar to Jejuri cab provides convenient transportation for devotees visiting Khandoba Temple. The route can also be included within a larger pilgrimage plan covering Morgaon, Narayanpur and nearby religious destinations."
},
{
name: "Karve Nagar to Ashtavinayak cab",
description: "Karve Nagar to Ashtavinayak cab provides private transportation for devotees planning visits to the Ashtavinayak temples. Multi-stop travel can be arranged according to the preferred pilgrimage route and schedule."
}
],
tableData: [
["Cab service in Kothrud"],
["Cab service in Kothrud Pune"],
["Taxi service in Kothrud"],
["Taxi service in Kothrud Pune"],
["Kothrud cab service"],
["Kothrud taxi service"],
["Cab booking in Kothrud"],
["Cabs in Kothrud Pune"],
["Cab near me in Kothrud"],
["Taxi near me in Kothrud"],
["Best cab service in Kothrud"],
["Affordable cab service in Kothrud"],
["Reliable taxi service Kothrud"],
["Kothrud to Pune Airport cab"],
["Pune Airport to Kothrud cab"],
["Kothrud to Pune Airport taxi"],
["Kothrud to Pune Airport cab fare"],
["Cheap airport cab from Kothrud"],
["outstation cab service in Kothrud"],
["One-way cab from Kothrud"],
["Round-trip cab from Kothrud"],
["Kothrud to Mumbai cab"],
["Kothrud to Shirdi cab"],
["Kothrud to Nashik cab"],
["Kothrud to Lonavala cab"],
["Kothrud to Mahabaleshwar cabm"],
["Kothrud to Bhimashankar cab"],
["Kothrud to Alibaug cab"],
["Kothrud to Kolhapur cab"],
["Kothrud to Goa cab"],
["Kothrud to Jejuri cab"],
["Kothrud to Ashtavinayak Cab"],
["outstation cab service in Karve Nagar"],
["one-way cab from Karve Nagar"],
["Round-trip taxi from Karve Nagar"],
["Karve Nagar to Mumbai Cab"],
["Karve Nagar to Shirdi cab"],
["Karve Nagar to Nashik cab"],
["Karve Nagar to Lonavala cab"],
["Karve Nagar to Mahabaleshwar cab"],
["Karve Nagar to Bhimashankar cab"],
["Karve Nagar to Alibaug cab"],
["Karve Nagar to Kolhapur cab"],
["Karve Nagar to Goa cab"],
["Karve Nagar to Jejuri cab"],
["Karve Nagar to Ashtavinayak cab"]
],
whychoose: [
{
WhyChooseheading: "Wide Kothrud Service Coverage",
WhyChoosedescription: "Citysky Cabs supports local and outstation transportation from Kothrud, making it convenient for residents, students, professionals, families and visitors to arrange private travel across Pune and beyond."
},
{
WhyChooseheading: "Dedicated Airport Connectivity",
WhyChoosedescription: "Direct cab arrangements between Kothrud and Pune Airport are useful for passengers with luggage and fixed flight schedules. Both airport departures and arrivals can be accommodated through private transportation."
},
{
WhyChooseheading: "Western Pune Accessibility",
WhyChoosedescription: "Cab routes can connect Kothrud with Karve Nagar, Bavdhan, Deccan and other Pune areas, helping passengers travel conveniently between residential communities, educational institutions, offices and commercial locations."
},
{
WhyChooseheading: "Popular Outstation Destinations",
WhyChoosedescription: "Private journeys from Kothrud can be arranged toward Mumbai, Shirdi, Nashik, Lonavala, Mahabaleshwar, Bhimashankar, Alibaug, Kolhapur and Goa for business, pilgrimage and leisure travel."
},
{
WhyChooseheading: "Flexible One-Way Travel",
WhyChoosedescription: "One-way cab arrangements provide a practical option for passengers who need direct transportation to another city without booking a return journey, including business travellers, family visitors and people relocating."
},
{
WhyChooseheading: "Comfortable Round-Trip Planning",
WhyChoosedescription: "Round-trip transportation is useful for travellers who want private travel for both onward and return journeys. It can suit weekend holidays, temple visits, family outings and business requirements."
},
{
WhyChooseheading: "Karve Nagar Route Support",
WhyChoosedescription: "Passengers from Karve Nagar can also arrange private outstation journeys toward Mumbai, Shirdi, Nashik, Lonavala, Mahabaleshwar, Bhimashankar, Alibaug, Kolhapur, Goa, Jejuri and Ashtavinayak destinations."
},
{
WhyChooseheading: "Suitable for Different Passenger Needs",
WhyChoosedescription: "Private cab arrangements can support individual passengers, couples, families, students, corporate travellers and groups for daily commuting, airport transfers, pilgrimages, holidays and long-distance road trips."
}
]
};











const faqData = [
{
question: "How can I arrange a Cab Service in Kothrud with Citysky Cabs?",
answer: "Passengers can enquire about cab service in Kothrud by sharing their pickup address, destination, travel date, preferred timing, and number of passengers. Citysky Cabs can assist with local transportation, airport and railway station transfers, office travel, family journeys, events, and outstation trips."
},
{
question: "Can I book a cab from Kothrud to Pune Airport?",
answer: "Travellers from Kothrud can enquire about a private airport cab based on their flight schedule. Providing the exact pickup location, preferred departure time, passenger count, and luggage details helps in arranging transportation according to the planned airport journey."
},
{
question: "Is Cab Service in Kothrud available for Pune Railway Station transfers?",
answer: "Passengers travelling by train can arrange a cab between Kothrud and Pune Railway Station according to their train schedule. The pickup point, train timing, number of passengers, and luggage requirements can be shared in advance to coordinate the railway station transfer."
},
{
question: "Can families hire a cab in Kothrud for local travel?",
answer: "Families can use cab transportation in Kothrud for shopping, medical appointments, family functions, airport transfers, railway station trips, and other local journeys. The trip can be planned according to the destination, passenger count, luggage, and preferred travel time."
},
{
question: "Can I book an outstation cab from Kothrud?",
answer: "Travellers based in Kothrud can enquire about outstation transportation for destinations outside Pune. Citysky Cabs can discuss one-way, round-trip, or multi-day requirements based on the destination, travel dates, number of passengers, luggage, and planned itinerary."
},
{
question: "Is Kothrud Cab Service suitable for corporate travel?",
answer: "Business travellers and companies can arrange cabs from Kothrud for office visits, client meetings, conferences, corporate events, and scheduled work travel. Transportation requirements can be discussed around the required pickup point, business destination, passenger count, and travel schedule."
},
{
question: "Can I get a cab from Kothrud for an early morning journey?",
answer: "Passengers requiring an early morning cab can mention their preferred pickup time while making an enquiry. Airport transfers, railway station journeys, business travel, and other scheduled trips can be discussed according to the route and timing required."
},
{
question: "Can senior citizens use Cab Service in Kothrud?",
answer: "Senior citizens and their families can enquire about private cab transportation for medical appointments, railway station transfers, airport journeys, family functions, and other travel needs. A direct vehicle can make the journey easier by reducing the need for multiple transport changes."
},
{
question: "Can I hire a cab from Kothrud for a family trip outside Pune?",
answer: "Families planning a holiday, pilgrimage, wedding visit, or weekend journey outside Pune can enquire about a private cab from Kothrud. The destination, travel dates, passenger count, luggage, additional stops, and return requirements can be shared while planning the trip."
},
{
question: "What details are required to book a Cab Service in Kothrud?",
answer: "For a cab enquiry, provide the Kothrud pickup location, destination, travel date, preferred departure time, number of passengers, and luggage details. If the journey involves an airport, railway station, corporate event, or outstation destination, sharing the relevant schedule and additional requirements can help organize the service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Aditya Deshpande",
feedback:
"I needed a cab from Kothrud to Pune Airport for a morning flight and wanted to arrange everything beforehand. I shared my pickup location and flight details with Citysky Cabs. The airport transfer was convenient, and I appreciated having a direct ride rather than arranging separate transport with luggage.",
rating: 5
},
{
id: 2,
name: "Miss. Meenal Shinde",
feedback:
"We had relatives coming to Kothrud for a family function and needed transportation for their railway station pickup and return trip. Citysky Cabs helped us coordinate the cab timings around their train schedule. It made managing the family's travel much easier during the busy function days.",
rating: 5
}
];



























































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kothrud",
  "image": "https://www.cityskycab.in/assets/images/cab-service-in-kothrud.webp",
  "description": "Cab Service in Kothrud from Citysky Cabs provides private taxi and car rental options for local travel, Pune Airport transfers, corporate journeys, family trips and outstation travel. The service covers Cab Service in Kothrud Pune, Taxi Service in Kothrud, Kothrud Cab Service, Kothrud Taxi Service, Cab Booking in Kothrud, Cabs in Kothrud Pune and nearby taxi requirements. Travellers can choose sedan, Ertiga or Innova Crysta vehicles according to passenger count, luggage and journey requirements. Pickup and drop services can be arranged across Kothrud and nearby Pune areas for local rides, airport transfers and business travel. Citysky Cabs also supports one-way and round-trip outstation cab bookings from Kothrud to Mumbai, Shirdi, Nashik, Mahabaleshwar, Lonavala and other destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/cab-service-in-kothrud"
  }
};



    return (
        <div>


<Helmet>
  <title>
    Cab Service in Kothrud | Airport & Outstation Taxi | +91 8554819191
  </title>

  <meta
    name="description"
    content="Cab Service in Kothrud by Citysky Cabs for local, airport and outstation travel. Book sedan, Ertiga or Innova Crysta for private taxi service in Kothrud Pune."
  />

  <meta
    name="keywords"
    content="Cab Service in Kothrud, Cab service in Kothrud Pune, Taxi service in Kothrud, Taxi service in Kothrud Pune, Kothrud cab service, Kothrud taxi service, Cab booking in Kothrud, Cabs in Kothrud Pune, Cab near me in Kothrud, Taxi near me in Kothrud, Best cab service in Kothrud, Affordable cab service in Kothrud, reliable cab service Kothrud, reliable taxi service Kothrud, taxi booking in Kothrud, online cab booking Kothrud, online taxi booking Kothrud, cab in Kothrud Pune, taxi in Kothrud Pune, local cab service Kothrud, local taxi service Kothrud, Kothrud local cab, Kothrud local taxi, private cab service Kothrud, cheap cab service Kothrud, 24 hour cab service Kothrud, 24x7 taxi service Kothrud, Kothrud airport cab service, Kothrud airport taxi service, Kothrud to Pune Airport cab, Kothrud to Pune Airport taxi, Pune Airport to Kothrud cab, Pune Airport to Kothrud taxi, Kothrud Pune Airport cab fare, Kothrud Pune Airport taxi fare, outstation cab service in Kothrud, outstation taxi service Kothrud, Kothrud outstation cab, Kothrud outstation taxi, one way cab from Kothrud, round trip cab from Kothrud, Kothrud intercity cab service, car rental in Kothrud Pune, Kothrud car rental service, Kothrud car hire, Kothrud sedan cab, Kothrud Ertiga cab, Kothrud Innova cab, Kothrud Innova Crysta cab, Kothrud AC cab, corporate cab service Kothrud, office cab service Kothrud, family cab service Kothrud, Kothrud to Mumbai cab, Kothrud to Mumbai Airport cab, Kothrud to Shirdi cab, Kothrud to Nashik cab, Kothrud to Mahabaleshwar cab, Kothrud to Lonavala cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keywords/37.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinkothrud;